import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const ref = (sp.get("ref") || "").toUpperCase();
  const [form, setForm] = useState({ name: "", business_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, ref });
      toast({ title: "Account created", description: "Let’s set up your voucher store." });
      nav("/dashboard");
    } catch (err) {
      toast({ title: "Sign up failed", description: err?.response?.data?.detail || "Please try again", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  const field = (label, key, type = "text", ph = "") => (
    <div>
      <label className="block text-sm font-medium text-[#16243b] mb-1.5">{label}</label>
      <input type={type} required value={form[key]} onChange={set(key)} placeholder={ph}
        className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" />
    </div>
  );

  return (
    <AuthLayout title="Start selling gift vouchers" subtitle="Free setup. No minimum term. £19.99/mo + 5% per sale.">
      {ref && <p className="mb-4 rounded-xl bg-[#eefafa] text-[#1fb0b0] text-sm px-4 py-3 font-medium" data-testid="signup-referral-notice">You've been referred by a fellow business (code {ref}).</p>}
      <form onSubmit={submit} className="space-y-4">
        {field("Your name", "name", "text", "Jane Smith")}
        {field("Business name", "business_name", "text", "The Anchor Hotel & Spa")}
        {field("Email", "email", "email", "you@business.com")}
        {field("Password", "password", "password", "Create a password")}
        <button disabled={loading} className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
          {loading ? "Creating account…" : "Create account"}
        </button>
      </form>
      <p className="text-sm text-[#5a6b80] mt-6 text-center">
        Already have an account? <Link to="/login" className="text-[#1fb0b0] font-medium hover:underline">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
